import React, { useEffect, useState } from 'react';

import moment from 'moment'

import { DatePicker, Form, Input, InputNumber, Radio } from 'antd';

import { bloodGroups, heightUnits, l2navoptions, pulseRateUnit, tempratureUnit, weightUnits, bodyTemperatureposition, pulseRatePosition, bloodPressureUnit }
    from '../../../../../..//Helpers/InterBranchConstants';
import Dropdown from '../../../../../DropDown/Dropdown';
import { useSelector, useDispatch } from "react-redux";
import { book_appointment, book_Videoconsultaton, Store_formData, update_patient_vital_info } from "../../../../../../actions/InterBranchCoordinatorAction"
import { convertDateToString } from '../../../../../../Helpers/dateFunctions';
import './patientvitals.css'
import { useHistory, useRouteMatch } from 'react-router-dom';
import { validateDataForFields } from '../../../../../../Helpers/helperFunctions';

function PatientVitals({ setActiveTop }) {


    let dispatch = useDispatch();
    let history = useHistory()
    let { path, url } = useRouteMatch();
    let reduxData = useSelector(state => state);
    let patientId = reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;
    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;
    const [buttonClicked, setButtonClicked] = useState(null);
    let patientDetails = useSelector(state => state.interBranchCoordinator?.interBranchPatientDetails?.data?.patientDetails);
    let { chosendoctorId, chosenDate, chosenTime, typeOfConsultation, couponCode } = reduxData?.interBranchCoordinator?.appointment_form;


    const [vitalsForm] = Form.useForm();

    const isScheduled = () => url.includes("scheduleappointment")

    let [formData, setFormData] = useState({

        heightValue: "",
        heightUnit: "",
        weightValue: "",
        weightUnit: "",
        bmiValue: "",
        bloodGroup: "",
        lmp: "",

        bloodPressurSystolic: "",
        bloodPressurDiastolic: "",
        bloodPressurunit: "mmHG",
        bloodPressurAsOn: "",

        bodyTempratureValue: "",
        bodyTempratureUnit: "",
        bodyTempratureAsOn: "",
        bodyTempraturePosition: "",

        PulseRateValue: "",
        PulseRateUnit: "Beats/Min",
        PulseRateAsOn: "",
        PulseRatePosition: "",

        RespirationValue: "",
        RespirationUnit: "Beats/Min",
        RespirationAsOn: "",

    })

    const [isEditted, setEditted] = useState(false)


    //This useEffect will change the state with redux data in loading time
    useEffect(() => {

        syncFormDataWithRedux(patientDetails?.basicInfo)

    }, [patientDetails])

    useEffect(() => {
        syncFormDataWithRedux()
    }, [appointment_form])


    useEffect(() => {

        syncFormDataWithRedux(appointment_form)

    }, [])


    // useEffect(() => {

    //     setFormData({ ...formData, bmiValue: calculateBMI() })

    // }, [formData.heightUnit, formData.heightValue, formData.weightUnit, formData.weightValue])




    //We can change the state by this method. (Object Itration in javascript)
    let handleChangeFormItem = ({ key, value }) => {


        setFormData({ ...formData, [key]: value })

    }



    let calculateBMI = ({ heightUnit, weightUnit, heightValue, weightValue }) => {




        if (heightUnit === "Inches") {
            heightValue = heightValue * 0.0254;
        } else if (heightUnit === "Feet") {
            heightValue = heightValue * 0.30;
        } else if (heightUnit === "Centimeter") {
            heightValue = heightValue * 0.01;
        }

        if (weightUnit === "lbs") {
            weightValue = weightValue * 0.45359237;
        }

        console.log("Calculating bmiValue.................", heightUnit, weightUnit, heightValue, weightValue);

        if (heightUnit && weightUnit && heightValue && weightValue) {



            let data = ((weightValue) / (heightValue * heightValue)).toFixed(3)

            setFormData({
                ...formData,
                bmiValue: data
            })

            console.log("Calculated bmiValue.................", data);
            vitalsForm.setFieldsValue({ bmiValue: data })

        }


    }


    let saveData = () => {

        //Function moved to onFinish of form...............
    }


    let syncFormDataWithRedux = (existingData) => {

        console.log(existingData);

        vitalsForm.setFieldsValue({
            heightValue: existingData?.heightValue,
            heightMeasurement: validateDataForFields(existingData?.heightMeasurement),
            weightMeasurement: validateDataForFields(existingData?.weightMeasurement),
            weightValue: existingData?.weightValue,

            bmiValue: existingData?.bmiValue,
            bloodGroup: validateDataForFields(existingData?.bloodGroup),
            lmp: existingData?.lmp ? moment(existingData.lmp) : "",

            bloodPressurSystolic: existingData?.bloodPressurSystolic,
            bloodPressurDiastolic: existingData?.bloodPressurDiastolic,
            bloodPressurunit: "mmHG",//appointment_form?.bloodPressurunit,
            bloodpressureMeasurementDate: existingData?.bloodpressureMeasurementDate ? moment(existingData.bloodpressureMeasurementDate) : "",

            bodyTempratureValue: existingData?.bodyTempratureValue,
            bodytempratureMeasurement:validateDataForFields(existingData?.bodytempratureMeasurement) ,
            bodytempratureMeasurementDate: existingData?.bodytempratureMeasurementDate ? moment(existingData.bodytempratureMeasurementDate) : "",
            bodyTempraturePosition: existingData?.bodyTempraturePosition,

            PulseRateValue: existingData?.PulseRateValue,
            PulseRateUnit: "Beats/Min",//appointment_form?.PulseRateUnit,
            pulserateMeasurementDate: existingData?.pulserateMeasurementDate ? moment(existingData.pulserateMeasurementDate) : "",
            PulseRatePosition: existingData?.PulseRatePosition,

            RespirationValue: existingData?.RespirationValue,
            RespirationUnit: "Beats/Min",//appointment_form?.RespirationUnit,
            RespirationMeasurementDate: existingData?.RespirationMeasurementDate ? moment(existingData.RespirationMeasurementDate) : "",

        })
    }

    let allowOnlyunumber = (e) => {

        if (e.target.value.includes(".") && e.key == ".") {
            e.preventDefault()
        }

        !["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "Backspace"].includes(e.key) && e.preventDefault()

    }



    const onFinishVitals = (values) => {

        if (buttonClicked === "Save") {
            console.log("Saving values :--------------- ", values);

            dispatch(
                Store_formData({
                    ...reduxData.interBranchCoordinator.appointment_form,
                    ...values
                })
            ).then((res) => {


                dispatch(update_patient_vital_info(patientId, { ...appointment_form, ...values }))

                setActiveTop(l2navoptions[1])

                history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/patientmedical/lifestyle`)

            })
        }
        if (buttonClicked === "Join") {
            try {
                dispatch(book_Videoconsultaton(patientId, userId, chosendoctorId, typeOfConsultation, couponCode, chosenTime, chosenDate, appointment_form)).
                    then((res) => {

                        if (res.data.appointmentId != "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {

                            localStorage.setItem("AppointmentId", res.data.appointmentId)
                            history.push("/joinconsultation/"+res.data.appointmentId);
                        }

                    })
            } catch (error) {
                //console.log("Error in book_appointment API", error);
            }
        }


    }

    const onFinishFailedVitals = (error) => {

        console.log(error);
    }

    const onChangeFieldValue = (value, allValues) => {


        if (
            !allValues.PulseRatePosition &&
            !allValues.PulseRateValue &&
            !allValues.RespirationMeasurementDate &&
            !allValues.RespirationValue &&
            !allValues.bloodGroup &&
            !allValues.bloodPressurDiastolic &&
            !allValues.bloodPressurSystolic &&
            !allValues.bloodpressureMeasurementDate &&
            !allValues.bmiValue &&
            !allValues.bodyTempraturePosition &&
            !allValues.bodyTempratureValue &&
            !allValues.bodytempratureMeasurement &&
            !allValues.bodytempratureMeasurementDate &&
            !allValues.heightMeasurement &&
            !allValues.heightValue &&
            !allValues.lmp &&
            !allValues.pulserateMeasurementDate &&
            !allValues.weightMeasurement &&
            !allValues.weightValue
        ) {

            console.log("No data filled................");
            setEditted(false)

        }
        else {
            setEditted(true)
        }


        let key = Object.keys(value)[0]

        if (key === "heightValue" || key === "heightMeasurement" || key === "weightValue" || key === "weightMeasurement") {

            calculateBMI({
                heightUnit: allValues?.heightMeasurement,
                weightUnit: allValues?.weightMeasurement,
                heightValue: allValues?.heightValue,
                weightValue: allValues?.weightValue,
            })

        }


    }


    console.log("..........................................", isEditted);


    return (

        <div className='patient-medical-container'>

            <Form
                form={vitalsForm}
                name="vitalsForm"
                onFinish={onFinishVitals}
                onFinishFailed={onFinishFailedVitals}
                onValuesChange={onChangeFieldValue}
                autoComplete="off"
                preserve={false}
            >

                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="caption">Height</div>

                        <div className='blue-light-back'>

                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`heightValue`}
                                initialValue={patientDetails?.basicInfo?.heightValue}
                            >
                                <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                    maxLength={6}
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "heightValue", value: e.target.value });
                                    }}

                                    // onKeyDown={validateNumber}
                                    // initialValue={heightValue}
                                    defaultValue={formData.heightValue}
                                    placeholder="Height" />

                            </Form.Item>
                            {/* ........................................................................................................... */}



                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`heightMeasurement`}
                            >
                                <Dropdown
                                    defaultValue={validateDataForFields(formData.heightUnit)}
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "heightMeasurement", value: e });
                                    }}
                                    data={heightUnits} width={100}
                                    placeholder="Select"
                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}

                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">Weight</div>

                        <div className='blue-light-back'>


                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`weightValue`}
                            >
                                <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input" min={1} maxLength={6} width={100}
                                    // onChange={validateNumber}
                                    defaultValue={formData.weightValue}
                                    placeholder="Weight"
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "weightMeasurement", value: e.target.value });
                                    }}

                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}


                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`weightMeasurement`}
                            >
                                <Dropdown
                                    defaultValue={formData.weightUnit}
                                    onChange={(e) => {
                                        handleChangeFormItem({ key: "weightUnit", value: e });
                                    }}
                                    data={weightUnits} width={100}
                                    placeholder="Select"
                                />

                            </Form.Item>
                            {/* ........................................................................................................... */}
                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">BMI</div>

                        <div className='blue-light-back'>

                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`bmiValue`}
                                initialValue={patientDetails?.basicInfo?.bmiValue}
                            >
                                <InputNumber
                                    onChange={(e) => { handleChangeFormItem({ key: "bmiValue", value: e }) }}
                                    width={100} style={{ margin: "0px !important" }}
                                    placeholder="BMI"
                                    readOnly
                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}
                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">Blood Group</div>

                        <div className='blue-light-back'>


                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`bloodGroup`}
                            >
                                <Dropdown
                                    defaultValue={formData.bloodGroup}
                                    onChange={(e) => { handleChangeFormItem({ key: "bloodGroup", value: e }) }}
                                    data={bloodGroups} width={100}
                                    placeholder="Select"
                                // onChange={(e) => setBloodGroup(e.value)} 
                                />
                            </Form.Item>
                            {/* ........................................................................................................... */}

                        </div>

                    </div>

                    <div className="item-container">

                        <div className="caption">LMP</div>

                        <div className='blue-light-back'>

                            {/* ........................................................................................................... */}
                            <Form.Item
                                name={`lmp`}
                            >
                                <DatePicker
                                    // defaultValue={moment(formData?.lmp ? formData.lmp : new Date())}
                                    defaultValue={moment(formData?.lmp)}
                                    getPopupContainer={trigger => trigger.parentNode}
                                    inputReadOnly
                                    placeholder='DD-MM-YYYY'
                                    format='DD-MM-yyyy'
                                    className='date-input'
                                    disabledDate={(current) => {
                                        return current && current.valueOf() > Date.now();
                                    }}
                                    onChange={(e) => { handleChangeFormItem({ key: "lmp", value: convertDateToString(e) }) }}
                                />

                            </Form.Item>
                            {/* ........................................................................................................... */}
                        </div>

                    </div>


                </div>



                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Blood Pressure</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodPressurSystolic`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        defaultValue={formData.bloodPressurSystolic}
                                        // onKeyDown={validateNumber}
                                        min={1}
                                        maxLength={6}
                                        onChange={(e) => { handleChangeFormItem({ key: "bloodPressurSystolic", value: e.target.value }) }}
                                        style={{ width: "120px" }} placeholder="Systolic" />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodPressurDiastolic`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        defaultValue={formData.bloodPressurDiastolic}
                                        // onKeyDown={validateNumber}
                                        maxLength={6}
                                        onChange={(e) => { handleChangeFormItem({ key: "bloodPressurDiastolic", value: e.target.value }) }}
                                        style={{ width: "120px" }} placeholder="Diastolic" />
                                </Form.Item>
                                {/* ........................................................................................................... */}



                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodPressurunit`}
                                >
                                    <Input
                                        defaultValue={formData.bloodPressurunit}
                                        style={{ width: "120px" }} width={100} placeholder={"mmHG"} readOnly />

                                </Form.Item>
                                {/* ........................................................................................................... */}



                                <span className='ason2'>as on</span>
                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bloodpressureMeasurementDate`}
                                >
                                    <DatePicker
                                        // defaultValue={moment(formData?.bloodPressurAsOn ? formData.bloodPressurAsOn : new Date())}
                                        defaultValue={moment(formData?.bloodPressurAsOn)}
                                        getPopupContainer={trigger => trigger.parentNode}
                                        inputReadOnly
                                        placeholder='DD-MM-YYYY'
                                        format='DD-MM-yyyy'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "bloodpressureMeasurementDate", value: d }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>
                </div>



                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Body Temperature</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodyTempratureValue`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        defaultValue={formData.bodyTempratureValue}
                                        onChange={(e) => { handleChangeFormItem({ key: "bodyTempratureValue", value: e.target.value }) }}
                                        min={1} maxLength={6}
                                        placeholder="Temperature"

                                    // onKeyDown={validateNumber} 
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodytempratureMeasurement`}
                                >
                                    <Dropdown
                                        defaultValue={formData.bodyTempratureUnit}
                                        data={tempratureUnit} width={150}
                                        placeholder="Select"
                                        onChange={(e) => { handleChangeFormItem({ key: "bodytempratureMeasurement", value: e }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                                <span className='ason2'>as on</span>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodytempratureMeasurementDate`}
                                >
                                    <DatePicker
                                        // defaultValue={moment(formData?.bodyTempratureAsOn ? formData.bodyTempratureAsOn : new Date())}
                                        defaultValue={moment(formData?.bodyTempratureAsOn)}
                                        getPopupContainer={trigger => trigger.parentNode}
                                        placeholder='DD-MM-YYYY'
                                        inputReadOnly format='DD-MM-yyyy'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "bodytempratureMeasurementDate", value: d }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`bodyTempraturePosition`}
                                >
                                    <Dropdown
                                        defaultValue={formData.bodyTempraturePosition}
                                        onChange={(e) => { handleChangeFormItem({ key: "bodyTempraturePosition", value: e }) }}
                                        data={bodyTemperatureposition} placeholder="Position" width={170}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>
                </div>


                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Pulse Rate</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`PulseRateValue`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        defaultValue={formData.PulseRateValue}
                                        onChange={(e) => { handleChangeFormItem({ key: "PulseRateValue", value: e.target.value }) }}
                                        min={1} maxLength={6}
                                        placeholder="Pulse"
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`PulseRateUnit`}
                                >
                                    <Input
                                        defaultValue={formData.PulseRateUnit}
                                        style={{ width: "120px" }} width={100} placeholder={"Beats/Min"} readOnly />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                <span className='ason2'>as on</span>

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`pulserateMeasurementDate`}
                                >
                                    <DatePicker
                                        // defaultValue={moment(formData?.PulseRateAsOn ? formData.PulseRateAsOn : new Date())}
                                        defaultValue={moment(formData?.PulseRateAsOn)}
                                        getPopupContainer={trigger => trigger.parentNode}
                                        inputReadOnly
                                        format='DD-MM-yyyy'
                                        placeholder='DD-MM-YYYY'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "pulserateMeasurementDate", value: d }) }}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`PulseRatePosition`}
                                >
                                    <Dropdown
                                        defaultValue={formData.PulseRatePosition}
                                        onChange={(e) => { handleChangeFormItem({ key: "PulseRatePosition", value: e }) }}
                                        data={pulseRatePosition} placeholder="Position" width={176}
                                    />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>
                </div>


                <div className="patient-medical-container_row">
                    <div className="item-container">

                        <div className="patient-medical-container_row">

                            <div className="caption">Respiration Rate</div>

                            {/* <Radio.Group value={1}>
                            <Radio value={1}>Physical</Radio>
                            <Radio value={2}>Connect a Device</Radio>ṣ
                        </Radio.Group> */}

                        </div>

                        <div className="patient-medical-container_row">

                            <div className='blue-light-back'>


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`RespirationValue`}
                                >
                                    <Input onKeyDown={allowOnlyunumber} className="patient-vitals-number-input"
                                        defaultValue={formData.RespirationValue}
                                        onChange={(e) => { handleChangeFormItem({ key: "RespirationValue", value: e.target.value }) }}
                                        min={1}
                                        maxLength={6}
                                        placeholder="Respiration" />
                                </Form.Item>
                                {/* ........................................................................................................... */}



                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`RespirationUnit`}
                                >
                                    <Input
                                        defaultValue={formData.RespirationUnit}
                                        style={{ width: "120px" }} width={100} placeholder={"Beats/Min"} readOnly />
                                </Form.Item>
                                {/* ........................................................................................................... */}


                                <span className='ason2'>as on</span>


                                {/* ........................................................................................................... */}
                                <Form.Item
                                    name={`RespirationMeasurementDate`}
                                >
                                    <DatePicker
                                        // defaultValue={moment(formData?.RespirationAsOn ? formData.RespirationAsOn : new Date())}
                                        defaultValue={moment(formData?.RespirationAsOn)}
                                        onChange={(e, d) => { handleChangeFormItem({ key: "RespirationMeasurementDate", value: d }) }}
                                        getPopupContainer={trigger => trigger.parentNode}
                                        inputReadOnly
                                        format='DD-MM-yyyy'
                                        placeholder='DD-MM-YYYY'
                                        className='date-input'
                                        disabledDate={(current) => {
                                            return current && current.valueOf() > Date.now();
                                        }} />
                                </Form.Item>
                                {/* ........................................................................................................... */}

                            </div>

                            {/* <div className="past-readings">
                            <img src={require('../../../../../../assets/InterBranch/PNGIcons/medical-records.png')} alt="" />
                            <span> See past readings</span>

                        </div> */}

                        </div>



                    </div>

                </div>



                <div className="button-container">

                    <button type='submit' className='submt-btn' disabled={!isEditted} onClick={() => { setButtonClicked("Save") }}>SAVE</button>


                    {
                        !isScheduled() &&
                        <button type='submit' className='join-btn' onClick={() => { setButtonClicked("Join") }}>SKIP AND JOIN CONSULTATION</button>
                        // :
                        // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                    }


                </div>

            </Form>
        </div>

    )
}

export default PatientVitals;
